<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_small">
            <cmp-calendar-small></cmp-calendar-small>
        </div>
        <div class="t-work-area__column_big t-applications" v-if="applications_length">
            <template v-for="(application, index_application) in applications">
                <h2 class="_blue">{{ pageText.title }} {{ application.time }}</h2>

                <h3 class="_blue" v-if="application.new.length">{{ pageText.type_1 }}</h3>
                <router-link :to="{name: 'user', params: {url: item.url}}"
                             class="t-applications__item t-applications-item" v-for="(item, index) in  application.new"
                             :key="'new_applications_' + index_application + '_' + index">
                    <img class="t-applications-item__img" :src="item.img !== '' ? item.img : '/img/default_img.png'">
                    <p class="t-applications-item__name">{{ item.name }}</p>
                    <button class="t-btn" @click.prevent="Confirm(item.id, application.id)"
                            v-if="application.confirmed.length < course.students"><span>{{ pageText.Confirm }}</span>
                    </button>
                    <button class="t-btn t-btn_white" @click.prevent="Reject(item.id, application.id)">
                        <span>{{ pageText.Reject }}</span>
                    </button>
                </router-link>

                <h3 class="_blue" v-if="application.confirmed.length">{{ pageText.type_2 }}</h3>
                <router-link :to="{name: 'user', params: {url: item.url}}"
                             class="t-applications__item t-applications-item"
                             v-for="(item, index) in application.confirmed"
                             :key="'confirmed_' + index_application + '_' + index">
                    <img class="t-applications-item__img" :src="item.img !== '' ? item.img : '/img/default_img.png'">
                    <p class="t-applications-item__name">{{ item.name }}</p>
                    <button class="t-btn t-btn_white" @click.prevent="Reject(item.id, application.id)"><span>{{ pageText.Reject }}</span>
                    </button>
                </router-link>

                <h3 class="_blue" v-if="application.rejected.length">{{ pageText.type_3 }}</h3>
                <router-link :to="{name: 'user', params: {url: item.url}}"
                             class="t-applications__item t-applications-item"
                             v-for="(item, index) in application.rejected"
                             :key="'rejected_' + index_application + '_' + index">
                    <img class="t-applications-item__img" :src="item.img !== '' ? item.img : '/img/default_img.png'">
                    <p class="t-applications-item__name">{{ item.name }}</p>
                    <span class="t-applications-item__state">{{ pageText.stateReject }}</span>
                </router-link>

                <h3 class="_blue" v-if="application.pending.length">{{ pageText.type_4 }}</h3>
                <router-link :to="{name: 'user', params: {url: item.url}}"
                             class="t-applications__item t-applications-item"
                             v-for="(item, index) in application.pending"
                             :key="'pending_' + index_application + '_' + index">
                    <img class="t-applications-item__img" :src="item.img !== '' ? item.img : '/img/default_img.png'">
                    <p class="t-applications-item__name">{{ item.name }}</p>
                </router-link>

                <h3 class="_blue" v-if="application.closed.length">{{ pageText.type_5 }}</h3>
                <router-link :to="{name: 'user', params: {url: item.url}}"
                             class="t-applications__item t-applications-item"
                             v-for="(item, index) in application.closed"
                             :key="'closed_' + index_application + '_' + index">
                    <img class="t-applications-item__img" :src="item.img !== '' ? item.img : '/img/default_img.png'">
                    <p class="t-applications-item__name">{{ item.name }}</p>
                </router-link>
            </template>
        </div>
        <div class="t-work-area__column_big t-applications" v-else>
            <div class="t-no-content">
                <h2>{{ pageText.applicationNotTitle }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseApplication.json' : 'staticText',
        main: {
            title: "Заявки на",
            type_1: "Новые",
            type_2: "Подтверждённые",
            type_3: "Отклонённые",
            type_4: "Ожидают завершение",
            type_5: "Завершены",
            Confirm: "Подтвердить",
            Reject: "Отклонить",
            stateReject: "Отклонено",
            applicationNotTitle: "Заявок на эту дату пока нет. Проверьте другие даты в календаре.",
            // applicationNotText: "Здесь будут отображаться заявки учеников на ваши уроки и курсы, вы сможете подтверждать или отклонять их.",
            msgConfirm: "Заявка подтверждена",
            msgReject: "Заявка отклонена"
        }
    };

    import {store} from '../../../store/index'

    import {mapActions, mapGetters} from 'vuex';

    import CalendarSmall from '../../../vue_components/Calendar_small/Calendar.vue'

    export default {
        data() {
            return {
                pageText: {},
                selectedDate: null,
            }
        },
        components: {
            'cmp-calendar-small': CalendarSmall
        },
        computed: {
            ...mapGetters('coursesList', ['course', 'applications', 'streams']),
            ...mapGetters('calendar_small', ['open_day', 'date_active']),
            applications_length() {
                let applications = 0;

                for (let a = 0; a < this.streams.length; a++) {
                    applications += this.streams[a].applications.confirmed;
                    applications += this.streams[a].applications.new;
                    applications += this.streams[a].applications.rejected;
                }

                return applications > 0
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('msg', ['showMsg']),
            ...mapActions('calendar_small', ['SetOpenDay', 'SetActiveDay']),
            ...mapActions('coursesList', ['LoadApplications', 'LoadStreams']),
            Confirm(userId, stream) {
                let fd = new FormData();

                fd.append('userId', userId);
                fd.append('stream', stream);

                this.$http.put('courses/' + this.course.id + '/applications/confirm', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.showMsg(this.pageText.msgConfirm);

                            let date_load = this.open_day.getFullYear() + '.' + (this.open_day.getMonth() + 1) + '.' + this.open_day.getDate();
                            this.LoadApplications({date: date_load, id: this.$route.params.id});
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            Reject(userId, stream) {
                // console.log(stream);
                // if (this.form.value !== -1 && this.lesson_in_day[index] && this.form.value === this.lesson_in_day[index]['id']) {
                //     let time = this.lesson_in_day[index]['time'].split('-')[0];
                //     let date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), time.split(':')[0], time.split(':')[1]);
                //     let curr = new Date();
                //     let res = Math.floor((date - curr) / 1000 / 60);
                //     this.disabledBtn = !(res > this.course.timeOuts.min_create_query);
                // }
                let fd = new FormData();

                fd.append('userId', userId);
                fd.append('stream', stream);

                this.$http.put('courses/' + this.course.id + '/applications/reject', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.showMsg(this.pageText.msgReject);

                            let date_load = this.open_day.getFullYear() + '.' + (this.open_day.getMonth() + 1) + '.' + this.open_day.getDate();
                            this.LoadApplications({date: date_load, id: this.$route.params.id});
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            Load(pageText) {
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            isAvailable() {
                let currentTime = new Date();
                return currentTime > this.open_day;
            }
        },
        watch: {
            open_day() {
                if (this.open_day !== null) {
                    let date_load = this.open_day.getFullYear() + '.' + (this.open_day.getMonth() + 1) + '.' + this.open_day.getDate();
                    this.LoadApplications({date: date_load, id: this.$route.params.id});
                }
            },
            date_active() {
                if (this.open_day !== null) {
                    let start = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.1';
                    let end = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.date_active.daysInMonth();
                    this.LoadStreams({start: start, end: end, id: this.$route.params.id}).then((data) => {
                        let min_date = '';

                        for (let s = 0; s < data.length; s++) {
                            for (let l = 0; l < data[s].lessons.length; l++) {
                                let day = new Date(data[s].lessons[l].date_time);
                                if (min_date === '')
                                    min_date = day;
                                else if (day < min_date)
                                    min_date = day;
                            }
                        }

                        if (this.$route.query.date) {
                          // let date = this.$route.query.date.split('.');
                          // this.SetOpenDay(new Date(date[0], date[1], date[2]));
                          // this.SetActiveDay(new Date(date[0], date[1], date[2]));
                        }
                        else if (min_date !== '') {
                            this.SetOpenDay(min_date);
                        }
                    });
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            this.SetOpenDay(null);
            next();
        },
        beforeRouteEnter(to, from, next) {
            let date = new Date(); // текущаяя дата

            if (to.query.date !== null && to.query.date) {
                 // если в гет параметре есть дата то сменить date на нее
                 // задать в vuex загрузку текущей даты
                let parsedDate = to.query.date.split('.');
                let dateformat = parsedDate[0] + '-' + parsedDate[1] + '-' + parsedDate[2];
                date = new Date(dateformat);
                if (date != 'Invalid Date') {
                    store.dispatch('calendar_small/SetOpenDay', date)
                } else {
                    date = new Date();
                }
            }

            if (!store.getters['coursesList/course'].belonging) {
                next({name: 'courses_info', params: {id: to.params.id}});
            }

            let start = date.getFullYear() + '.' + (date.getMonth() + 1) + '.1';
            let end = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.daysInMonth();

            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('calendar_small/LoadCalendarSmallText').then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if (count > 1) {
                    store.dispatch('coursesList/LoadStreams', {
                        start: start,
                        end: end,
                        id: to.params.id
                    }).then((data) => {
                        let min_date = ''; // минимальная дата в выдаче, для того что бы вывести ее заявки
                        if (store.getters['calendar_small/open_day'] === null) {
                            for (let s = 0; s < data.length; s++) {
                                for (let l = 0; l < data[s].lessons.length; l++) {
                                    let day = new Date(data[s].lessons[l].date_time);
                                    if (min_date === '')
                                        min_date = day;
                                    else if (day < min_date)
                                        min_date = day;
                                }
                            }
                        } else {
                            min_date = store.getters['calendar_small/open_day'];
                        }

                        if (min_date === '') {
                            next(vm => vm.Load(pageText))
                        } else {
                            let date_load =min_date.getFullYear() + '.' + (min_date.getMonth() + 1) + '.' + min_date.getDate();
                            store.dispatch('coursesList/LoadApplications', {
                                date: date_load,
                                id: to.params.id
                            }).then(() => {
                                if (to.query.date !== null && to.query.date && store.getters['calendar_small/date_active'] !== min_date) {
                                    store.dispatch('calendar_small/SetActiveDay', min_date);
                                }
                                if (store.getters['calendar_small/open_day'] === null) {
                                    store.dispatch('calendar_small/SetOpenDay', min_date);
                                }
                                next(vm => vm.Load(pageText))
                            });
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="sass">
    .t-applications
        &__item
            + h3, + h2
                margin-top: 32px !important
            + .t-applications__item
                margin-top: 8px

    .t-applications-item
        display: flex
        align-items: center
        justify-content: space-between
        padding: 8px 16px 8px 8px
        background: #ffffff
        box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
        border-radius: 16px
        &__img
            width: 56px
            height: 56px
            object-fit: cover
            flex: none
            margin-right: 8px
            border-radius: 8px
        &__name
            flex: 1
            padding-right: 24px
        &__state
            flex: none
            color: $red
            padding: 0 24px
            margin-left: 8px
            font-size: 16px
            font-weight: bold
        .t-btn
            flex: none
            &:last-child
                margin-left: 8px

    @media(max-width: 769px)
        .t-applications
            h2
                padding: 0 16px
                margin-bottom: 16px
            h3
                padding: 0 16px
        .t-applications-item
            padding: 8px
            flex-wrap: wrap
            max-width: 520px
            margin: 0 auto
            &__name
                flex: none
                flex-grow: 1
                width: calc(100% - 64px)
                & + .t-btn:last-child
                    width: 100%
            &__state
                margin-left: 0
                margin-top: 18px
                text-align: center
                width: 100%
            .t-btn
                width: calc(50% - 16px)
                margin-top: 8px
    @media(max-width: 500px)
        .t-applications-item
            max-width: unset
            .t-btn
                width: 100%
                margin-top: 8px
                &:last-child
                    margin-left: 0

    .t-no-content
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        width: 439px
        height: 100%
        h2
            color: $blue
            font-size: 36px
        @media(max-width: 769px)
            width: 100%
            p 
                text-align: center
                width: calc(100% - 16px)
                margin: 0 auto
            h2
                font-size: 24px

</style>



// WEBPACK FOOTER //
// src/vue_pages/Courses/View/Applications.vue